import { render, staticRenderFns } from "./AdminUsers.vue?vue&type=template&id=a5961314&scoped=true"
import script from "./AdminUsers.vue?vue&type=script&lang=js"
export * from "./AdminUsers.vue?vue&type=script&lang=js"
import style0 from "./AdminUsers.vue?vue&type=style&index=0&id=a5961314&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5961314",
  null
  
)

export default component.exports